// extracted by mini-css-extract-plugin
export default {"wrap":"Switch_wrap__CxNrm","label":"Switch_label__I5Ogt","leftLabel":"Switch_leftLabel__VJabU","on":"Switch_on__P3Zts","icon":"Switch_icon__6JsYK"};